var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id},[_vm._t("default",null,{"item":item})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }